import { render, staticRenderFns } from "./AstaTavoloGriglia.vue?vue&type=template&id=216731da&scoped=true&"
import script from "./AstaTavoloGriglia.vue?vue&type=script&lang=js&"
export * from "./AstaTavoloGriglia.vue?vue&type=script&lang=js&"
import style0 from "./AstaTavoloGriglia.vue?vue&type=style&index=0&id=216731da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216731da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216731da')) {
      api.createRecord('216731da', component.options)
    } else {
      api.reload('216731da', component.options)
    }
    module.hot.accept("./AstaTavoloGriglia.vue?vue&type=template&id=216731da&scoped=true&", function () {
      api.rerender('216731da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaTavoloGriglia.vue"
export default component.exports